<template>
  <v-sheet color="bg1" height="100%" width="100%">
    <v-card
      height="100%"
      flat
      class="rounded-0 rounded-tl-lg pa-4 overflow-hidden"
      :loading="modelsLoading">
      <div
        class="pa-2 d-flex align-center"
        style="gap: 8px"
        :class="{
          'flex-wrap': $vuetify.breakpoint.xs,
        }">
        <h3>Markups Stamps</h3>
      </div>
      <div class="pa-4">
        <!--Folders List-->
        <AdminStampsFolder :key="folder.id" :folder="folder"></AdminStampsFolder>
        <!--Confirmation Messages-->
        <div class="info-section" style="align-items: center">
          <input
            type="file"
            webkitdirectory
            multiple
            style="display: none"
            id="browsePointCloudFile"
            @change="onPointCloudFileChanged($event)" />
          <progress
            style="width: 50%; height: 20px"
            v-if="isUploadingPointCloud"
            min="0"
            :max="maxProgress"
            step="1"
            :value="progress"></progress>
          <div v-if="isUploadingPointCloud">
            {{ progress }}/{{ maxProgress }} Files
            {{ isDeleting ? 'Deleted' : 'Uploaded' }}
          </div>
          <div style="display: flex; width: 100%; justify-content: center"></div>
        </div>
      </div>
    </v-card>
  </v-sheet>
</template>

<script>
  /* eslint-disable no-unused-vars */
  import { toggleExpandComponent } from '@/scripts/js/forgeviewer';
  import { ForgeMarkupStamp } from '@/scripts/js/forgeModels';
  import { getAllMarkupStamps, saveMarkupStamp } from '@Utils/mongoUtils';
  export default {
    name: 'AdminStamps',
    components: {
      AdminStampsFolder: () => import('@/components/admin/components/stamps/adminStampsFolder.vue'),
    },
    emits: ['update_category', 'delete_category'],
    props: ['modelsLoading'],
    data() {
      return {
        isExpanded: false,
        isUploadingPointCloud: false,
        progress: 0,
        maxProgress: 100,
        isDeleting: false,
        searchText: '',
        folderPath: '',
        itemsTree: [],
        folder: [],
      };
    },
    async mounted() {
      var allMarkupStamps = await getAllMarkupStamps();
      this.itemsTree = this.getStampsTree(allMarkupStamps);
      this.folders = this.itemsTree.folders;
      this.folder = {
        name: 'Markups Stamps',
        stamps: this.itemsTree.stamps,
        folders: this.folders,
        path: '',
        id: this.$store.state.forgeService.newGuid(),
      };
    },
    methods: {
      addNewStamp(folder) {
        var _this = this;
        this.$store.dispatch({
          type: 'prompt_Forge_Extended',
          title: 'Add new Stamp',
          callback: (inputs) => {
            var name = inputs[0].trim();
            var svgText = inputs[1];
            var stamp = new ForgeMarkupStamp();
            stamp.name = name;
            stamp.createDate = new Date().toDateString();
            stamp.userId = _this.$store.state.username;
            stamp.createdBy = _this.$store.state.username;
            stamp.svgText = svgText;
            stamp.folderPath = _this.folderPath;
            saveMarkupStamp(stamp);
            _this.getCurrentNode().stamps.push(stamp);
          },
          input: {
            inputName: 'Name',
            inputValue: '',
          },
          extendedInput: {
            inputName: 'SVG Text',
            inputValue: '',
          },
        });
      },
      getStampsTree(stamps) {
        let tree = {
          name: '',
          stamps: [],
          folders: [],
        };
        for (let stamp of stamps) {
          if (!stamp.folderPath) tree.stamps.push(stamp);
          else {
            let folders = stamp.folderPath.split('/');
            let folderToAddInto = tree;
            let path = '';
            for (let name of folders) {
              path += path ? '/' + name : name;
              let folder = folderToAddInto.folders.find((o) => o.name == name);
              if (!folder) {
                folder = {
                  name: name,
                  stamps: [],
                  folders: [],
                  path: path,
                  id: this.$store.state.forgeService.newGuid(),
                };
                folderToAddInto.folders.push(folder);
              }
              folderToAddInto = folder;
            }
            folderToAddInto.stamps.push(stamp);
          }
        }
        return tree;
      },
      getCurrentNode() {
        let node = this.itemsTree;
        if (!this.folderPath) return node;
        let folders = this.folderPath.split('/');
        for (let folder of folders) {
          node = node.folders.find((o) => o.name == folder);
        }
        return node;
      },
      toggleExpandedFolder(path) {
        var _this = this;
        if (_this.folderPath === path) {
          //Navigate up
          var lastSlash = path.lastIndexOf('/');
          var parentPath = path.slice(0, lastSlash);
          _this.folderPath = parentPath;
        } else {
          _this.folderPath = path;
        }
      },
      toggleExpanded() {
        toggleExpandComponent(this);
      },
    },
  };
</script>
